<template>
  <div class="main">
    <div class="wrapper">
      <div class="title-container" id="home">
        <div class="title">
          <h1>Av. Negru Marian Liviu</h1> &nbsp;<h3><i> - baroul Sălaj</i></h3>
          <h5><i class="fa fa-envelope envelope-icon"></i>{{ email }}</h5>
        </div>
      </div>
      <Header />
      <div class="top-section-wrapper">
        <About />
      </div>
      <div class="section moto-container">
        <div class="text-center moto">
          <p>"Justitia domina et regina omnium virtutum"</p>
        </div>
        <div class="ciocan-judecator">
          <img src="../assets/ciocan.jpeg" alt="ciocan">
        </div>
      </div>
      <div class="section" id="domains">
        <Domains />
      </div>
      <div class="section" id="contact">
        <Contact />
      </div>
      <div class="section" id="sediu">
        <Office />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './Header.vue';
import About from './About.vue'; 
import Footer from './Footer.vue';
import Contact from './Contact.vue';
import Domains from './Domains.vue';
import Office from './Office.vue';
import { EMAIL, PHONE } from '../constants';
export default {
  name: 'Index',
  components: { Header, About, Footer, Contact, Domains, Office},
  props: { },
  data: function () {
      return {
      email: EMAIL,
      phone: PHONE,
    }
  },
}
</script>
<style scoped lang="scss">
@import "../scss/_variables.scss";

.title-container {
  color: $theme-color;
  padding: 30px 15px 15px 15px;
  background-color: $bg-color;
  text-align: center;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #6f757b;
}
.title {
  width: 1130px;
  margin: auto;

  h1, h3 {
    display: inline-block;
  }

  .envelope-icon {
    margin-right: 10px;
  }
}
.wrapper {
  background-color: white;
  box-shadow: 0px 3px 16px 0px $bg-color;

  .profile-picture {
    padding: 50px 0;
  }
}

.wrapper .top-section-wrapper { 
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #262626;
  margin-bottom: 40px;
  box-shadow: 0 15px 15px rgba(182, 182, 182, 0.75);

  .top-section {
    height: 400px;
    background-color: $bg-color;
    margin: auto;
    border-radius: 3px;
  }
}
.image {
  max-width:100%;
  max-height:100%;
}
.section {
  min-height: 500px;
  padding-bottom: 50px;
  background-color: white;
}
.section-icons {
  height: 185px;
  background-color: #f2f2f2;
  border-top: 1px solid #6f757b;
  text-align: center;
  font-size: 50px;
  margin: 0;
}

.ciocan-judecator {
  text-align: center;
  margin-bottom: 20px;
}
.moto {
  color: red;
  font-style: italic;
  font-size: 22px;
  margin-top: 20px;
}

.moto-container {
  min-height: 430px;
  padding-bottom: 0 !important;
  display: flex;
  align-items: center;
  flex-direction: column;
}

@media only screen and (max-width: 991px) {
  .main > .wrapper > .title-container > .title {
    h1 {
      font-size: 1.8rem;
    }
    h3 {
      font-size: 1.4rem;
    }
    h5 {
      font-size: 1.1rem;
    }

  }
}
</style>
